import { motion, type Variants } from "framer-motion";

const PORTRAIT =
  "https://images.unsplash.com/photo-1634983703546-0b3d4a2a829b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBmYXNoaW9uJTIwcG9ydHJhaXQlMjBtaW5pbWFsfGVufDB8fHx8MTc4NTMwMTM5M3ww&ixlib=rb-4.1.0&q=85";

interface Quote {
  quote: string;
  name: string;
  role: string;
}

const quotes: Quote[] = [
  {
    quote: "I come for the perfumes, leave with half the snack aisle.",
    name: "Ananya R.",
    role: "Regular since day one",
  },
  {
    quote: "Groceries done in twelve minutes flat. Clean layout, fair prices, staff who actually know where things are.",
    name: "Marcus D.",
    role: "Weekly shopper",
  },
  {
    quote: "The chocolate selection alone is worth the trip. Nothing else in the city comes close for the price.",
    name: "Priya K.",
    role: "Chocolate devotee",
  },
];

const reveal: Variants = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export const Testimonials = () => (
  <section id="testimonials" className="pt-12 lg:pt-16 pb-24 lg:pb-32" data-testid="testimonials-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="lg:col-span-4 lg:sticky lg:top-28"
      >
        <span className="font-mono-acc uppercase tracking-[0.2em] text-xs text-vg-gray">03 / Voices</span>
        <h2 className="font-heading font-black tracking-tighter text-5xl md:text-6xl mt-4">
          WHAT THE<br />
          <span className="text-outline">CITY SAYS</span>
        </h2>
        <div className="img-frame border border-black/10 mt-10 hidden lg:block">
          <img src={PORTRAIT} alt="VG Mart customer portrait" className="w-full h-72 object-cover grayscale" />
        </div>
      </motion.div>

      <motion.div
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.15 } } }}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-100px" }}
        className="lg:col-span-8 flex flex-col"
      >
        {quotes.map((q, i) => (
          <motion.blockquote
            key={q.name}
            variants={reveal}
            className="border-t border-black/10 py-12 grid md:grid-cols-12 gap-6 group"
            data-testid={`testimonial-${i + 1}`}
          >
            <div className="md:col-span-2 font-heading font-black text-4xl text-outline-num">0{i + 1}</div>
            <div className="md:col-span-10">
              <p className="font-heading font-light text-2xl md:text-4xl tracking-tight leading-snug">
                “{q.quote}”
              </p>
              <footer className="mt-6 flex items-center gap-4">
                <span className="w-8 h-px bg-vg-cyan" />
                <span className="font-mono-acc uppercase tracking-[0.2em] text-xs">
                  {q.name} — <span className="text-vg-gray">{q.role}</span>
                </span>
              </footer>
            </div>
          </motion.blockquote>
        ))}
      </motion.div>
    </div>
  </section>
);

export default Testimonials;
